export const kebabToCamelConverter = (string) => string.replace(/-./g, (x) => x.toUpperCase()[1]);
//# sourceMappingURL=kebabToCamel.js.map